/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useTargetContext from '../context/useTargetContext';

function Table() {
  //
  const {
    auth,
    activeTab,
    targetData,
    loading,
    handleJustification,
    setRowsSelected,
    handleUpdateAll,
    approveStatusValue,
  } = useContext(useTargetContext);
  const justificationColumn =
    activeTab !== 0 ? [{ field: 'justification', headerName: 'Justification', minWidth: 200 }] : [];

  const actionButton =
    (activeTab === 0 && auth.level !== 'Level 3') ||
    (activeTab === 1 &&
      (auth.level === 'Level 3' || auth.level === 'Level 4' || auth.level === 'Admin')) ||
    (activeTab === 2 && (auth.level === 'Level 4' || auth.level === 'Admin'))
      ? [
          {
            field: 'action',
            headerName: 'Action',
            minWidth: 240,
            maxWidth: 240,
            renderCell: ({ row }) => (
              <div>
                <Button
                  size='small'
                  variant='contained'
                  color='success'
                  onClick={(e) => handleJustification(row.id, approveStatusValue, false)}
                  startIcon={<CheckIcon />}
                >
                  Approve
                </Button>
                &nbsp;
                <Button
                  size='small'
                  variant='contained'
                  color='error'
                  onClick={(e) => handleJustification(row.id, 3, false)}
                  startIcon={<DeleteIcon />}
                >
                  Reject
                </Button>
              </div>
            ),
          },
        ]
      : [];
  let approverColumns = [];

  if (activeTab === 1) {
    approverColumns = [{ field: 'first_approver', headerName: 'First Approver', minWidth: 200 }];
  } else if (activeTab === 2) {
    approverColumns = [
      { field: 'first_approver', headerName: 'First Approver', minWidth: 200 },
      { field: 'second_approver', headerName: 'Second Approver', minWidth: 200 },
    ];
  }
  const columns = [
    { field: 'md_name', headerName: 'MD Name', minWidth: 200 },
    { field: 'classification', headerName: 'Classification', minWidth: 100 },
    { field: 'current_target', headerName: 'Current Target', minWidth: 120 },
    {
      field: 'new_target',
      headerName: 'New Target',
      minWidth: 100,
      renderCell: ({ row }) => <div style={{ color: 'red' }}>{row.new_target}</div>,
    },
    { field: 'date_requested', headerName: 'Date Requested', minWidth: 200 },
    { field: 'requested_by', headerName: 'Requested By', minWidth: 200 },
    { field: 'reason', headerName: 'Reason for Update', minWidth: 200 },
    ...justificationColumn,
    { field: 'date_from', headerName: 'Effective From', minWidth: 150 },
    { field: 'date_to', headerName: 'Effective Until', minWidth: 150 },
    { field: 'temporary', headerName: 'Temporary', minWidth: 120 },
    ...approverColumns,
    ...actionButton,
  ];

  return (
    <Grid container spacing={2}>
      {(activeTab === 0 && auth.level !== 'Level 3') ||
      (activeTab === 1 &&
        (auth.level === 'Level 3' || auth.level === 'Level 4' || auth.designation === 'admin')) ||
      (activeTab === 2 && (auth.level === 'Level 4' || auth.designation === 'admin')) ? (
        <Grid xs={12} sm={12} md={12}>
          <Button
            size='small'
            variant='contained'
            color='success'
            sx={{ float: 'right' }}
            onClick={(e) => handleJustification(null, approveStatusValue, true)}
            startIcon={<CheckIcon />}
          >
            Approve All Selected
          </Button>
        </Grid>
      ) : (
        ''
      )}
      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '800px', marginLeft: '20px' }}>
          &nbsp;
          <DataGridPro
            rows={targetData}
            columns={columns}
            loading={loading}
            checkboxSelection
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = targetData.filter((row) => selectedIDs.has(row.id));
              setRowsSelected(selectedRows);
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
}
export default Table;
